/**
 * Gewinnspiel signup form: upload button trigger, file name display, submit button validation
 */
(function () {
  const form = document.querySelector('[data-signup-form]');
  if (!form) return;

  const fileInput = form.querySelector('[data-signup-receipt-input]');
  const uploadTrigger = form.querySelector('[data-signup-upload-trigger]');
  const fileNameEl = form.querySelector('[data-signup-file-name]');
  const submitBtn = form.querySelector('[data-signup-submit]');

  const requiredInputs = form.querySelectorAll('input[required], select[required]');

  function isFormValid() {
    for (let i = 0; i < requiredInputs.length; i++) {
      const el = requiredInputs[i];
      if (el.type === 'checkbox') {
        if (!el.checked) return false;
      } else if (el.type === 'file') {
        if (!el.files || el.files.length === 0) return false;
      } else {
        const val = (el.value || '').trim();
        if (!val) return false;
      }
    }
    if (fileInput && (!fileInput.files || fileInput.files.length === 0)) return false;
    return true;
  }

  function updateSubmitButton() {
    if (!submitBtn) return;
    const valid = isFormValid();
    submitBtn.disabled = !valid;
  }

  // Initial state
  updateSubmitButton();

  // Revalidate on input/change
  const fieldsContainer = form.querySelector('.gewinnspiel-signup__fields');
  if (fieldsContainer) {
    fieldsContainer.addEventListener('input', updateSubmitButton);
    fieldsContainer.addEventListener('change', updateSubmitButton);
  }

  if (uploadTrigger && fileInput) {
    uploadTrigger.addEventListener('click', function () {
      fileInput.click();
    });
  }

  if (fileInput && fileNameEl) {
    fileInput.addEventListener('change', function () {
      const file = fileInput.files[0];
      fileNameEl.textContent = file ? file.name : '';
      updateSubmitButton();
    });
  }

  function showError(msg) {                                                                                                                                                                                                    
    var existing = form.querySelector('.gewinnspiel-signup__error');                                                                                                                                                           
    if (existing) existing.remove();                                                                                                                                                                                           
    var el = document.createElement('div');                                                       
    el.className = 'gewinnspiel-signup__error';                                         
    el.innerHTML = msg;                                                                                                                                                                                                        
    form.prepend(el);            
  }  

  // Submit via fetch — Shopify App Proxy converts native form POSTs to GET,
  // which hits the loader (405). Using fetch() preserves the POST method.
  form.addEventListener('submit', function (e) {
    e.preventDefault();

    if (!isFormValid() || submitBtn.disabled) {
      return;
    }

    submitBtn.disabled = true;
    submitBtn.textContent = 'WIRD GESENDET...';

    fetch(new URL(form.action).pathname, {                                                                                                                                                                                         
      method: 'POST',                                                                                                                                                                                                              
      body: new FormData(form),                                                                                                                                                                                                    
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data.ok) {
          form.innerHTML = '<p class="gewinnspiel-signup__success">' + data.message + '</p>';
        } else if (data.errors) {
          showError(Object.values(data.errors).join('<br>'));
          submitBtn.disabled = false;
          submitBtn.textContent = 'ABSENDEN';
        } else {
          showError(data.message || 'Ein Fehler ist aufgetreten.');
          submitBtn.disabled = false;
          submitBtn.textContent = 'ABSENDEN';
        }
      })
      .catch(function () {
        showError('Ein Fehler ist aufgetreten. Bitte versuche es erneut.');
        submitBtn.disabled = false;
        submitBtn.textContent = 'ABSENDEN';
      });
  });
})();
